module.exports = __webpack_public_path__ + "img/9788958201809.3827eb8b.jpg";